import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import ConfiguracionWSCTG from './ConfiguracionWSCTG'
import ConfiguracionVolcadoras from './ConfiguracionVolcadoras'
import { FORM_CONFIGURACION_SISTEMA } from '../../../../config/forms'
import { obtenerEstadoCTGPostergada, obtenerDuracionDeVolcado, updateEstadoCTGPostergada, updateDuracionDeVolcado } from '../../actions'

function ConfiguracionDeSistema (props) {
  const { obtenerEstadoCTGPostergada, obtenerDuracionDeVolcado, estadoWSCTG } = props

  useEffect(() => {
    obtenerEstadoCTGPostergada()
    obtenerDuracionDeVolcado()
  }, [obtenerEstadoCTGPostergada, obtenerDuracionDeVolcado])

  const updateWSCTG = (newValue) => {
    props.updateEstadoCTGPostergada(newValue)
  }

  const updateDuracionVolcado = () => {
    props.updateDuracionDeVolcado(props.duracionVolcado)
  }

  return (
    <>
      <h4 style={{ margin: '' }}>Configuración del sistema</h4>
      <Row style={{ alignItems: 'center' }}>
        <Col md={4}>
          <div className='container-config-sistema'>
            <ConfiguracionWSCTG
              updateWSCTG={updateWSCTG}
              estadoWSCTG={estadoWSCTG}
            />
          </div>
        </Col>
        <Col md={8}>
          <div className='container-config-sistema'>
            <ConfiguracionVolcadoras
              updateDuracionVolcado={updateDuracionVolcado}
              duracion={props.duracion}
            />
          </div>
        </Col>
      </Row>
    </>
  )
}

const selector = formValueSelector(FORM_CONFIGURACION_SISTEMA)

const mapStateToProps = (state) => ({
  estadoWSCTG: state.dashboard.wsctg,
  duracion: state.dashboard.duracionVolcado,
  duracionVolcado: selector(state, 'duracionVolcado')
})

const mapActionToProps = {
  obtenerDuracionDeVolcado,
  obtenerEstadoCTGPostergada,
  updateDuracionDeVolcado,
  updateEstadoCTGPostergada
}

const withRedux = connect(mapStateToProps, mapActionToProps)

const withReduxForm = reduxForm({
  form: FORM_CONFIGURACION_SISTEMA
})

export default withRedux(withReduxForm(ConfiguracionDeSistema))
